import { useUserIsAbroad } from 'app/hooks/useUserIsAbroad';
import React, { useState, useMemo } from 'react';

type UserContextType = {
    isAbroad: boolean;
    isWatchingBreakingNews: boolean;
    setIsWatchingBreakingNews: (b: boolean) => void;
};

export const UserContext = React.createContext<UserContextType>({
    isAbroad: false,
    isWatchingBreakingNews: false,
    setIsWatchingBreakingNews: () => ({}),
});

export const UserContextProvider: React.FC<unknown> = ({ children }): React.ReactElement => {
    const isAbroad = useUserIsAbroad();
    const [isWatchingBreakingNews, setIsWatchingBreakingNews] = useState(false);
    // eslint-disable-next-line react/jsx-no-constructed-context-values

    const value = useMemo(
        () => ({ isAbroad, isWatchingBreakingNews, setIsWatchingBreakingNews }),
        [isAbroad, isWatchingBreakingNews, setIsWatchingBreakingNews]
    );

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
